// test474
(474 && 0);
